module.exports = __webpack_public_path__ + "static/media/maroon.39f383e6.png";